import React from 'react';
import { useTranslation } from 'react-i18next';

import { QBox, QIcon, QTooltip } from '@qualio/ui-components';

type InheritedTemplateIconProps = {
  templateId: number;
  parentName: string;
};

export const InheritedTemplateIcon: React.FC<InheritedTemplateIconProps> = ({ templateId, parentName }) => {
  const { t } = useTranslation();
  const description = t('template.list.table.inheritedTooltip', { parentName });

  return (
    <QTooltip label={description}>
      <QBox
        as="span"
        display="inline-flex"
        flexShrink={0}
        role="img"
        aria-label={description}
        data-cy={`inherited-template-icon-${templateId}`}
      >
        <QIcon iconName="Related" color="blue.400" />
      </QBox>
    </QTooltip>
  );
};
